export function evenlyDistrubuteArrayOfArrays(
  arr: any[],
  numberOfArrays: number
): any {
  const arrOfArr: any = new Array(numberOfArrays);
  for (let i = 0; i < numberOfArrays; i++) {
    arrOfArr[i] = [];
  }
  let currArrOfArrIndex = 0;
  for (let i = 0; i < arr.length; i++) {
    arrOfArr[currArrOfArrIndex].push(arr[i]);
    currArrOfArrIndex++;
    if (currArrOfArrIndex === numberOfArrays) {
      currArrOfArrIndex = 0;
    }
  }
  return arrOfArr;
}
